import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class AgentsValidationTableCtrl implements IController {
  agents: any;
  selectedIds: any;
  isEditable: any;
  queryString: any;
  onSelectedIdsChanged: Function;
  onRemove: Function;
  onEdit: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }


  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
  };

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggleAgent(agentId) {
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if(value) return key;
    });
    this.onSelectedIdsChanged({selectedIds : _.compact(selectedIds)});
  }

  onToggleAllAgents() {
    var selectedIds = !_.isEqual(this.selectedIds.length, this.agents.length) ?
      _.map(this.agents, (agent) => {
        return agent.agentId;
      }) : [];

    this.onSelectedIdsChanged({selectedIds : selectedIds});
  }

  onRemoveAgent(id) {
    this.onRemove({ids: [id]});
  }

  onEditAgent(agent) {
    this.onEdit({agent: agent})
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentsValidationTable', {
    bindings: {
      agents: '<',
      selectedIds: '<',
      isEditable: '<',
      queryString: '<',
      onSelectedIdsChanged: '&',
      onRemove: '&',
      onEdit: '&'
    },
    template: require('./agents-validation-table.html').default,
    controller: AgentsValidationTableCtrl
  });
